import React from "react";
import Select from "react-select";
import moment from "moment";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { ButtonGroup, Button } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown, faPlus, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

import FeatureChartContainer from "containers/FeatureChart/FeatureChart";
import PartialDepPlotContainer from "containers/RunPlot/PartialDepPlot";
import DriverGraphContainer from "containers/RunPlot/DriverGraph";
import WizardModelContainer from "containers/Wizard/WizardModel";

import UploadModal from "components/View/UploadModal";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { LineInput } from "components/Inputs/LineInput";

import BullseyeBlue from "images/bullseye-arrow-light-blue.svg";
import AcademicBlue from "images/academic-blu.svg";
import CSVIcon from "images/EDG/DB/CSVIcon.svg";
import DatasetPurpleIcon from "images/tileIcons/dataset_purple.svg";
import TableauIcon from "images/TableauIcon.png";
import AibleWelcomeIcon from "images/AibleWelcomeIcon.svg";

import { MINI_BLUEPRINTS } from "components/Results/AcademicResults";

import styles from "./style.module.css";

export default class WizardMini extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showDrivers: false,
      miniHover: false,
      showAllModels: props.isDeployList === true ? true : false,
      isPartial: false,
      modelSearch: undefined,
      datasetSearch: undefined,
      isDatasetSelection: true,
      showUploadModal: false,
      outcomes: {},
      tBlueprint: undefined
    };
  }

  setModal(value = false) {
    return this.setState({ showUploadModal: value });
  }

  handleFile(event) {
    const { handleFileChange, validateFileExtension } = this.props;

    const file = event.currentTarget.files ? event.currentTarget.files[0] : undefined;

    if (validateFileExtension(file)) {
      this.setModal(false);
      return handleFileChange(file, event.currentTarget);
    }
  }

  getCreateDataset() {
    const { setupDatasetId, datasets } = this.props;

    return setupDatasetId !== undefined && datasets && datasets.filter((d) => d.id === setupDatasetId).length > 0
      ? datasets.filter((d) => d.id === setupDatasetId)[0]
      : undefined;
  }

  getFormattedDrivers(prediction) {
    const { colSelections } = this.props;

    if (prediction === undefined) {
      return undefined;
    }

    var drivers = prediction;

    drivers.sort(function (a, b) {
      if (a.impact > b.impact) return 1;
      if (b.impact > a.impact) return -1;

      return 0;
    });

    var formattedDrivers = [];

    var isLargestPositive = true;
    var isLargestNegative = true;

    for (var i = 0; i < drivers.length; i++) {
      var driver = drivers[i];
      var value = colSelections[driver.variable];

      if (formattedDrivers.length >= 3) {
        break;
      } else if (value !== undefined && driver.impact != 0) {
        var label = driver.variable + ": ";
        label += value + " had ";
        var direction;

        if (driver.impact < 0) {
          if (isLargestNegative) {
            label += "the largest ";
            isLargestNegative = false;
          } else {
            label += "a ";
          }

          label += "negative impact";
          direction = "Negative";
        } else {
          if (isLargestPositive) {
            label += "the largest ";
            isLargestPositive = false;
          } else {
            label += "a ";
          }

          label += "positive impact";
          direction = "Positive";
        }

        formattedDrivers.push({
          label: label,
          direction: direction
        });
      }
    }

    return formattedDrivers;
  }

  renderPredictionNarrative(formattedDrivers) {
    const { showDrivers } = this.state;

    return (
      <div className={styles.dHoldNarrative} style={showDrivers ? { display: "none" } : {}}>
        <div className={styles.dHeader}>{"Top Prediction Drivers"}</div>
        {formattedDrivers.map((f, i) => (
          <div className={styles.dFieldPredict} key={i}>
            {f.direction === "Positive" ? (
              <div className={styles.dItem}>
                <span className={styles.dIconGood}>
                  <FontAwesomeIcon icon={faArrowUp} />
                </span>
              </div>
            ) : (
              <div className={styles.dItem}>
                <span className={styles.dIconBad}>
                  <FontAwesomeIcon icon={faArrowDown} />
                </span>
              </div>
            )}
            <div className={styles.dItem}>{f.label}</div>
          </div>
        ))}
      </div>
    );
  }

  renderSummary() {
    const { model, scenarios, scenarioIndex, getModelFeature } = this.props;
    const { showDrivers, largeScenario } = this.state;

    const featureBars =
      model && model.featureInfo && model.featureInfo.length > 0
        ? model.featureInfo.map((f) => ({
            left: f.score,
            label: f.label,
            leftModel: model.id,
            values: getModelFeature(model.id, f.label).values
          }))
        : [];

    const scenario =
      scenarios && scenarios.filter((s) => s.id === scenarioIndex).length > 0
        ? scenarios.filter((s) => s.id === scenarioIndex)[0]
        : undefined;

    const prediction = scenario ? scenario.predictions : undefined;

    const retPrediction =
      prediction && prediction[0] && prediction[0].info && prediction[0].info.rowLevelDrivers
        ? prediction[0].info.rowLevelDrivers
        : undefined;

    const formattedDrivers = this.getFormattedDrivers(retPrediction);

    return (
      <div
        className={styles.drivers}
        style={
          showDrivers
            ? {
                marginTop: largeScenario ? "40vh" : "80vh",
                paddingTop: "0px",
                height: largeScenario ? "calc(100% - 40vh)" : "100%"
              }
            : {}
        }
      >
        {formattedDrivers && formattedDrivers.length > 1 ? (
          this.renderPredictionNarrative(formattedDrivers)
        ) : (
          <div className={styles.dHold} style={showDrivers ? { display: "none" } : {}}>
            <div className={styles.dHeader}>{"Top Model Drivers"}</div>
            {featureBars &&
              featureBars
                .filter((f, i) => i < 3)
                .map((f, i) => {
                  let maxValue = undefined;
                  let maxKey = undefined;

                  let minValue = undefined;
                  let minKey = undefined;

                  for (const val of Object.keys(f.values)) {
                    if (maxValue === undefined || f.values[val] >= maxValue) {
                      maxValue = f.values[val];
                      maxKey = val;
                    }

                    if (minValue === undefined || f.values[val] <= minValue) {
                      minValue = f.values[val];
                      minKey = val;
                    }
                  }

                  return (
                    <div className={styles.dField} key={i}>
                      <div className={styles.dItem}>
                        <span className={styles.bold}>{f.label}</span>
                        <span>
                          {i === 0
                            ? " is the most impactful driver"
                            : i === 1
                              ? " is the second most impactful driver"
                              : i === 2
                                ? " is the third most impactful driver"
                                : " is an impactful driver"}
                        </span>
                      </div>
                      <div className={styles.dItem}>
                        <span className={styles.dIconGood}>
                          <FontAwesomeIcon icon={faArrowUp} />
                        </span>
                        <span className={styles.bold}>{maxKey}</span>
                        <span>{" is the strongest positive"}</span>
                      </div>
                      <div className={styles.dItem}>
                        <span className={styles.dIconBad}>
                          <FontAwesomeIcon icon={faArrowDown} />
                        </span>
                        <span className={styles.bold}>{minKey}</span>
                        <span>{" is the strongest negative"}</span>
                      </div>
                    </div>
                  );
                })}
          </div>
        )}
        {this.renderPredict()}
      </div>
    );
  }

  renderDrivers() {
    const { id } = this.props;
    const { showDrivers, largeScenario, projectId } = this.state;

    return (
      <div
        className={styles.driverHolder}
        style={
          showDrivers
            ? {
                height: largeScenario ? "40vh" : "80vh",
                borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                paddingTop: "45px"
              }
            : { height: "0%", paddingTop: "0px" }
        }
        onClick={showDrivers ? () => this.setState({ largeScenario: false }) : () => {}}
      >
        <FeatureChartContainer
          id={id}
          isHideSelect
          predictMode={"predict"}
          featureStyle={{
            border: "none",
            margin: "0px",
            background: "rgba(250, 250, 250, 1)"
          }}
          isTabMini
          projectId={projectId}
        />
      </div>
    );
  }

  renderPredict() {
    const { id } = this.props;
    const { showDrivers, largeScenario, projectId } = this.state;

    return (
      <div
        className={styles.predictHolder}
        onClick={showDrivers ? () => this.setState({ largeScenario: true }) : () => {}}
      >
        <FeatureChartContainer
          id={id}
          isSmall
          predictMode={"predict"}
          featureStyle={{ display: "none" }}
          projectId={projectId}
        />
      </div>
    );
  }

  renderMiniHeader() {
    const { aibleMode, outcome, datasetLabel, model, created } = this.props;
    const { miniHover } = this.state;

    return (
      <div
        className={styles.miniHeader}
        onMouseEnter={() => this.setState({ miniHover: true })}
        onMouseLeave={() => this.setState({ miniHover: false })}
      >
        {miniHover ? (
          <div className={styles.modelInfo}>
            <div className={styles.imgContainerLarge}>
              <img src={aibleMode == "academic" ? AcademicBlue : BullseyeBlue} />
            </div>
            <div>
              <div className={styles.boldLine}>{"Predict " + outcome}</div>
              <div className={styles.line}>{"Data: " + datasetLabel}</div>
              <div className={styles.line}>{"Model Type: " + model.label}</div>
              <div className={styles.line}>{"Created: " + created}</div>
            </div>
          </div>
        ) : (
          <div className={styles.line}>
            <div className={styles.imgContainer}>
              <img src={aibleMode == "academic" ? AcademicBlue : BullseyeBlue} />
            </div>
            {"Predict " + outcome}
          </div>
        )}
      </div>
    );
  }

  renderAllModels() {
    const { openProject, projects, handleDeleteProject, updateDatasetId, history } = this.props;
    const { modelSearch } = this.state;

    return (
      <div className={styles.aMiniWizard}>
        {/*
        <div className={styles.allHeader}>
          {projects && projects.length > 0
            ? "View or create a project"
            : "Loading projects..."}
          {projects.length > 0 && (
            <LineInput
              isMediumBox
              placeholder={"Search..."}
              style={{
                width: "calc(100% - 190px)",
                justifyContent: "flex-end",
              }}
              onChange={(val) => this.setState({ modelSearch: val })}
              value={modelSearch}
              key="modelSearch"
              updateInstant
            />
          )}
        </div>
        */}
        <div className={styles.wizardAllWithFooter}>
          <WizardModelContainer
            isCreate
            onClick={() => {
              updateDatasetId(undefined);
              this.setState({ isDatasetSelection: true });
            }}
          />
          {projects ? (
            projects
              .filter((p) => p.name !== undefined)
              .filter(
                (p) => modelSearch === undefined || p.name.toLowerCase().indexOf(modelSearch.toLowerCase()) !== -1
              )
              .map((p, i) => (
                <div key={i}>
                  <WizardModelContainer
                    project={p}
                    isFull
                    onClick={() => openProject(p.id)}
                    handleDeleteProject={handleDeleteProject}
                  />
                </div>
              ))
          ) : (
            <div className={styles.modelLoading}>
              <LoadingIndicator style={{ margin: "0px", padding: "0px", marginLeft: "-20px" }} />
            </div>
          )}
        </div>
      </div>
    );
  }

  renderSelectBlueprint() {
    return (
      <div className={styles.miniHeaderFull}>
        <div className={styles.modelInfo}>
          <div className={styles.imgContainerLarge + " " + styles.fImg}>
            <FontAwesomeIcon icon={faPlus} />
          </div>
          <div className={styles.modelStuff}>
            <div className={styles.boldLine}>{"Select a Blueprint (optional)"}</div>
          </div>
        </div>
      </div>
    );
  }

  renderDatasetSelected(createDataset) {
    const { updateDatasetId, initJob, introspectCounts, setup, setupSuccess, updateSuccess, updateLabel } = this.props;

    const outcomeField =
      createDataset && createDataset.fields && createDataset.outcome && createDataset.fields[createDataset.outcome]
        ? createDataset.fields[createDataset.outcome]
        : undefined;

    const isCategorical = outcomeField && outcomeField.type === "categorical";

    return (
      <div className={styles.aMiniWizard}>
        <div className={styles.allHeader} style={{ textAlign: "center" }}>
          {"Prediction Name: "}
          <LineInput
            isMediumBox
            placeholder={"Name..."}
            style={{
              width: "calc(100% - 130px)",
              justifyContent: "flex-end"
            }}
            onChange={(val) => updateLabel(val)}
            value={setup ? setup.label : undefined}
            updateInstant
          />
        </div>
        <div>{this.renderDataset(createDataset, true)}</div>
        {isCategorical && outcomeField.data ? (
          <div className={styles.successHolder}>
            <div className={styles.boldLine}>{"Select the outcome to predict"}</div>
            <Select
              placeholder="Select a value"
              options={outcomeField.data.map((v) => ({
                label: v.value + " (" + v.count + ")",
                value: v.value,
                count: v.count
              }))}
              onChange={(val) => {
                updateSuccess(val);
                introspectCounts();
              }}
            />
          </div>
        ) : (
          <div />
        )}
        {this.renderAssumptions(isCategorical && outcomeField.data)}
        <div className={styles.actionButtons}>
          <Button onClick={() => updateDatasetId(undefined)}>{"Back"}</Button>
          <Button type="primary" disabled={isCategorical && setupSuccess === undefined} onClick={() => initJob()}>
            {"Create"}
          </Button>
        </div>
      </div>
    );
  }

  renderAssumptions(hasSuccess) {
    const {
      id,
      setup,
      initCustomBlueprint,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateCustomValue,
      setupSuccess,
      updateSuccess,
      blueprint,
      blueprints,
      updateBlueprintId
    } = this.props;

    const { tBlueprint } = this.state;

    return setup === undefined ? (
      <div />
    ) : (
      <div>
        <div style={{ margin: "20px" }}>
          <div className={styles.boldLine}>
            {"Select a Blueprint"}
            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top" title={"Blueprint"}>
                  <div className={styles.innerWarnings}>
                    {"Aible blueprints bring together the best in data science, " +
                      "domain expertise and modeling for business impact, giving you AI superpowers. " +
                      "Your blueprint will help you identify your relative cost-benefits and " +
                      "evaluate your AI models for maximum net business impact."}
                  </div>
                </Popover>
              }
            >
              <FontAwesomeIcon
                icon={faQuestionCircle}
                style={{
                  marginLeft: "5px",
                  marginBottom: "2px",
                  color: "#333"
                }}
              />
            </OverlayTrigger>
          </div>
          <div style={{ zIndex: 5 }}>
            <Select
              options={
                blueprints
                  ? [
                      { label: "Continue Without Blueprint", value: "NONE" },
                      ...blueprints.map((b) => ({
                        label: b.name,
                        value: b.id,
                        blueprint: b
                      }))
                    ]
                  : []
              }
              value={
                tBlueprint && blueprints && blueprints.filter((b) => b.id === tBlueprint.id).length > 0
                  ? {
                      label: blueprints.filter((b) => b.id === tBlueprint.id)[0].name,
                      value: blueprints.filter((b) => b.id === tBlueprint.id)[0].id
                    }
                  : { label: "Continue Without Blueprint", value: "NONE" }
              }
              menuPlacement="bottom"
              onChange={(val) => {
                const retSuccess = setupSuccess;
                this.setState({ tBlueprint: val.blueprint });
                updateBlueprintId(val.value);
                if (retSuccess !== undefined) {
                  updateSuccess(retSuccess);
                }
              }}
            />
          </div>
        </div>
        <div
          className={styles.blueprintHolder}
          style={{
            height: hasSuccess ? "calc(100vh - 545px)" : "calc(100vh - 465px)"
          }}
        >
          {tBlueprint === undefined && MINI_BLUEPRINTS ? (
            <div className={styles.miniBlueprintHolder}>
              <div className={styles.miniBlueprintList}>
                {Object.keys(MINI_BLUEPRINTS).map((k) => (
                  <div
                    className={
                      styles.miniBlueprint +
                      " " +
                      (setup.conversionGain === MINI_BLUEPRINTS[k].truePositive &&
                      setup.conversionCost === MINI_BLUEPRINTS[k].falsePositive
                        ? styles.miniBlueprintSelected
                        : "")
                    }
                    onClick={() => {
                      updateConversionGain(MINI_BLUEPRINTS[k].truePositive);
                      updateConversionCost(MINI_BLUEPRINTS[k].falsePositive);
                    }}
                    key={k}
                  >
                    <div className={styles.miniBlueprintName}>{MINI_BLUEPRINTS[k].name}</div>
                    <div className={styles.miniBlueprintCost}>
                      {MINI_BLUEPRINTS[k].truePositive +
                        ":" +
                        Math.abs(MINI_BLUEPRINTS[k].falsePositive) +
                        " cost ratio"}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className={styles.advBlueprint}>
              <div className={styles.aHolder}>
                {Object.keys(setup.customValues).map((v, i) => (
                  <div style={{ marginTop: "20px" }} key={i}>
                    <LineInput
                      isMediumBox
                      topLabel={v}
                      labelStyle={{ zIndex: 0, color: "#4B495B" }}
                      value={setup.customValues[v]}
                      onChange={(val) => updateCustomValue(id, tBlueprint.id, v, val)}
                    />
                  </div>
                ))}
              </div>
              <div style={{ marginTop: "20px" }}>
                <LineInput
                  isMediumBox
                  labelStyle={{ zIndex: 0, color: "#4B495B" }}
                  topLabel={setup.truePositiveLabel}
                  value={setup.conversionGain}
                  onChange={(val) => updateConversionGain(val)}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <LineInput
                  isMediumBox
                  labelStyle={{ zIndex: 0, color: "#4B495B" }}
                  topLabel={setup.falsePositiveLabel}
                  value={setup.conversionCost}
                  onChange={(val) => updateConversionCost(val)}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <LineInput
                  isMediumBox
                  labelStyle={{ zIndex: 0, color: "#4B495B" }}
                  topLabel={setup.trueNegativeLabel}
                  value={setup.conversionSaved}
                  onChange={(val) => updateConversionSaved(val)}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <LineInput
                  isMediumBox
                  labelStyle={{ zIndex: 0, color: "#4B495B" }}
                  topLabel={setup.falseNegativeLabel}
                  value={setup.conversionMissed}
                  onChange={(val) => updateConversionMissed(val)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderDatasetImport(isTableauImport) {
    const { useUploadModal, handleTableauUpload, isTabUploading, isDataUploading } = this.props;

    return (
      <div className={styles.emptyButton}>
        {isTableauImport && isTabUploading ? (
          <div className={styles.emptyModelInfo}>
            <LoadingIndicator style={{ margin: "0px", marginRight: "20px" }} />
            <div className={styles.modelStuff}>
              <div className={styles.boldLine}>{"Importing data from dashboard..."}</div>
            </div>
          </div>
        ) : isTableauImport !== true && isDataUploading ? (
          <div className={styles.emptyModelInfo}>
            <LoadingIndicator style={{ margin: "0px", marginRight: "20px" }} />
            <div className={styles.emptyModelStuff}>
              <div className={styles.boldLine}>{"Uploading..."}</div>
            </div>
          </div>
        ) : (
          <div className={styles.emptyModelInfo}>
            {isTableauImport ? (
              <div className={styles.emptyImg}>
                <img src={TableauIcon} style={{ height: "44px", width: "44px" }} />
              </div>
            ) : (
              <div className={styles.emptyImg}>
                <img src={CSVIcon} style={{ height: "44px", width: "44px" }} />
              </div>
            )}
            <div className={styles.emptyModelStuff}>
              <Button
                type={isTableauImport ? "primary" : undefined}
                onClick={
                  isTableauImport
                    ? () => handleTableauUpload()
                    : useUploadModal
                      ? () => this.setModal(true)
                      : () => document.getElementById("fUpload").click()
                }
              >
                {isTableauImport ? "Evaluate Data from Tableau" : "Upload CSV"}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderDataset(dataset, isNoHover = false) {
    const { updateDatasetId, updateLabel, handleChangeOutcome, handleDeleteDataset, handleUpload } = this.props;

    const chosenOutcome = this.state.outcomes && dataset ? this.state.outcomes[dataset.id] : undefined;

    const isProcessing =
      dataset.rowCount === -1 &&
      dataset.errors.length === 0 &&
      dataset.status &&
      (dataset.status.indexOf("missing_target_variable") === -1 ||
        dataset.status.indexOf("not_indexed") === -1 ||
        dataset.dataset_status !== "DONE");

    return (
      <div
        className={
          isNoHover ||
          (dataset && dataset.outcome === undefined) ||
          (dataset && dataset.dataset_status === "ERROR") ||
          isProcessing
            ? styles.miniHeaderNoHover
            : styles.miniHeaderFull
        }
        onClick={
          dataset && dataset.outcome !== undefined && isProcessing === false
            ? () => {
                updateLabel(dataset.name);
                updateDatasetId(dataset.id);
              }
            : () => {}
        }
      >
        {dataset && dataset.id !== undefined && (
          <div className={styles.delHolder}>
            <Button
              style={{ padding: "2px" }}
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteDataset(dataset.id);
              }}
            >
              {"Delete"}
            </Button>
          </div>
        )}
        <div className={styles.modelInfo}>
          <div className={styles.imgContainerLarge + " " + styles.pBack}>
            <img src={DatasetPurpleIcon} />
          </div>
          {dataset && dataset.dataset_status === "ERROR" ? (
            <div className={styles.modelStuff}>
              <div className={styles.boldLineD}>{dataset.name}</div>
              <div className={styles.line} style={{ display: "flex" }}>
                <span className={styles.leftLine}>{"Error Loading Dataset"}</span>
              </div>
            </div>
          ) : isProcessing ? (
            <div className={styles.modelStuff}>
              <div className={styles.boldLineD}>{dataset.name}</div>
              <div className={styles.line} style={{ display: "flex" }}>
                <LoadingIndicator style={{ margin: "0px" }} />
                <span
                  className={styles.leftLine}
                  style={{
                    marginLeft: "15px",
                    fontSize: "18px",
                    fontWeight: "300"
                  }}
                >
                  {"Evaluating Data Quality..."}
                </span>
              </div>
            </div>
          ) : dataset && dataset.outcome ? (
            <div className={styles.modelStuff}>
              <div className={styles.boldLineD}>{dataset.name}</div>
              <div className={styles.line} style={{ display: "flex" }}>
                <span className={styles.leftLine}>{"Columns:"}</span>
                {dataset.fields ? Object.keys(dataset.fields).length : 0}
              </div>
              <div className={styles.line} style={{ display: "flex" }}>
                <span className={styles.leftLine}>{"Outcome:"}</span>
                {dataset.outcome}
              </div>
              {dataset.warnings && dataset.warnings.length > 0 ? (
                <OverlayTrigger
                  placement="top"
                  trigger={["click"]}
                  rootClose
                  overlay={
                    <Popover id="popover-positioned-top" title={dataset.warnings.length + " Data Alerts"}>
                      <div className={styles.innerWarnings}>
                        {dataset.warnings.map((warning, index) => {
                          const wMessage =
                            warning.metadata && warning.metadata.message
                              ? warning.metadata.message
                              : warning.code === "MissingValuesWarning" &&
                                  warning.metadata &&
                                  warning.metadata.column &&
                                  warning.metadata.percentage
                                ? "Column '" +
                                  warning.metadata.column +
                                  "' has missing data: " +
                                  warning.metadata.percentage +
                                  "% of all values are empty."
                                : warning.code === "PIIDetectedWarning" &&
                                    warning.metadata &&
                                    warning.metadata.column &&
                                    warning.metadata.pii_type
                                  ? "Column '" +
                                    warning.metadata.column +
                                    "' may have personally identifiable information of type: " +
                                    warning.metadata.pii_type
                                  : warning.message;

                          return (
                            <div key={wMessage} className={styles.innerRow}>
                              {wMessage}
                            </div>
                          );
                        })}
                      </div>
                    </Popover>
                  }
                >
                  <div
                    className={styles.line}
                    style={{ display: "flex", width: "100px" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <span className={styles.leftLine}>{"Data Alerts:"}</span>
                    <a className={styles.errorTrigger}>{dataset.warnings.length}</a>
                  </div>
                </OverlayTrigger>
              ) : (
                <div className={styles.line} style={{ display: "flex" }}>
                  <span className={styles.leftLine}>{"Data Alerts:"}</span>
                  <div>{"None"}</div>
                </div>
              )}

              <div className={styles.line} style={{ display: "flex" }}>
                <span className={styles.leftLine}>{"Created:"}</span>
                {moment.utc(dataset.created_date).local().fromNow()}
              </div>
            </div>
          ) : (
            <div className={styles.modelStuff}>
              <div className={styles.boldLine}>{dataset.name}</div>
              <div className={styles.line} style={{ display: "flex" }}>
                <span style={{ width: "60%", marginRight: "10px" }}>
                  <Select
                    options={
                      dataset && dataset.fields
                        ? Object.keys(dataset.fields).map((f) => ({
                            label: f,
                            value: f
                          }))
                        : []
                    }
                    placeholder="Select Outcome"
                    onChange={(val) =>
                      this.setState({
                        outcomes: {
                          ...this.state.outcomes,
                          [dataset ? dataset.id : 0]: val
                        }
                      })
                    }
                  />
                </span>
                <Button
                  onClick={() => {
                    handleChangeOutcome(chosenOutcome);
                    handleUpload(dataset ? dataset.id : 0);
                  }}
                  disabled={chosenOutcome === undefined}
                >
                  {"Select"}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderSubHeader() {
    const { projects } = this.props;
    const { isDatasetSelection } = this.state;

    return (
      <div className={styles.menuHolder}>
        <div
          className={styles.menuTab + " " + (isDatasetSelection === true ? styles.menuTabSelected : "")}
          onClick={() => this.setState({ isDatasetSelection: true })}
          title={"View Data"}
        >
          {"Data"}
        </div>
        <div
          className={styles.menuTab + " " + (isDatasetSelection !== true ? styles.menuTabSelected : "")}
          style={projects && projects.length === 0 ? { pointerEvents: "none", opacity: "0.5" } : {}}
          title={projects && projects.length === 0 ? "No Predictions" : "View Predictions"}
          onClick={() => this.setState({ isDatasetSelection: false })}
        >
          {"Predictions"}
        </div>
      </div>
    );
  }

  renderCreate() {
    const { datasets, selectedAccountId } = this.props;
    const { showUploadModal, datasetSearch } = this.state;

    return (
      <div className={styles.aMiniWizard}>
        {/*
        <div className={styles.allHeader}>
          {datasets && datasets.length > 0
            ? "Select a dataset"
            : "Loading Datasets..."}
          {datasets.length > 0 && (
            <LineInput
              isMediumBox
              placeholder={"Search..."}
              style={{
                width: "calc(100% - 170px)",
                justifyContent: "flex-end",
              }}
              onChange={(val) => this.setState({ datasetSearch: val })}
              value={datasetSearch}
              key="datasetSearch"
              updateInstant
            />
          )}
        </div>
        */}
        <div className={styles.wizardAllWithFooter}>
          <div className={styles.topAdj}>
            {this.renderDatasetImport(true)}
            {this.renderDatasetImport()}
          </div>
          {datasets && datasets.length > 0 ? (
            datasets
              .filter(
                (d) =>
                  d.name === undefined ||
                  datasetSearch === undefined ||
                  d.name.toLowerCase().indexOf(datasetSearch.toLowerCase()) !== -1
              )
              .map((d, i) => <div key={i}>{this.renderDataset(d)}</div>)
          ) : (
            <div className={styles.modelLoading}>
              <LoadingIndicator style={{ margin: "0px", padding: "0px", marginLeft: "-20px" }} />
            </div>
          )}
        </div>
      </div>
    );
  }

  renderWelcome() {
    const { handleTableauUpload, useUploadModal, isTabUploading, isDataUploading } = this.props;

    return (
      <div className={styles.welcomeHolder} style={{ height: "calc(100vh - 100px)" }}>
        <div className={styles.welcomeButtonHero}>
          <div className={styles.welcomeButtonImage}>
            <img src={AibleWelcomeIcon} style={{ height: "50px", width: "50px" }} />
          </div>
          <div className={styles.wBold}>{"Welcome to Aible!"}</div>
          <div className={styles.wMsg}>
            {"Empower everyone in your organization to run what-if " +
              "scenarios and get  actionable predictions with predictive " +
              "models built right within Tableau."}
          </div>
        </div>
        {isTabUploading ? (
          <div className={styles.welcomeButton}>
            <div className={styles.welcomeButtonImage}>
              <LoadingIndicator />
            </div>
            <div className={styles.boldLine}>{"Importing data from dashboard..."}</div>
          </div>
        ) : (
          <div className={styles.welcomeButton}>
            <div className={styles.welcomeButtonImage}>
              <img src={TableauIcon} style={{ height: "85px", width: "85px" }} />
            </div>
            <Button type={"primary"} onClick={() => handleTableauUpload()}>
              {"Start from Tableau Data"}
            </Button>
          </div>
        )}
        {isDataUploading ? (
          <div className={styles.welcomeButton}>
            <div className={styles.welcomeButtonImage}>
              <LoadingIndicator />
            </div>
            <div className={styles.boldLine}>{"Uploading..."}</div>
          </div>
        ) : (
          <div className={styles.welcomeButton}>
            <div className={styles.welcomeButtonImage}>
              <img src={CSVIcon} style={{ height: "85px", width: "85px" }} />
            </div>
            <Button
              onClick={useUploadModal ? () => this.setModal(true) : () => document.getElementById("fUpload").click()}
            >
              {"Start From CSV"}
            </Button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      id,
      blueprintId,
      model,
      outcome,
      isProjectsLoading,
      isDatasetsLoading,
      datasets,
      projects,
      fieldSelect,
      updateFieldSelect,
      selectedAccountId,
      updateLabel,
      updateDatasetId
    } = this.props;
    const { showDrivers, isPartial, showAllModels, isCreate, isDatasetSelection, showUploadModal } = this.state;

    const createDataset = this.getCreateDataset();

    if (createDataset !== undefined || isCreate || showAllModels) {
      return (
        <div className={styles.miniHolder}>
          {this.renderSubHeader()}
          {isProjectsLoading || isDatasetsLoading ? (
            <div className={styles.modelLoading}>
              <LoadingIndicator style={{ margin: "0px", padding: "0px", marginTop: "20px" }} />
            </div>
          ) : isProjectsLoading === false &&
            isDatasetsLoading === false &&
            projects &&
            datasets &&
            projects.length === 0 &&
            datasets.length === 0 &&
            false ? (
            this.renderWelcome()
          ) : createDataset !== undefined && isDatasetSelection ? (
            this.renderDatasetSelected(createDataset)
          ) : isDatasetSelection ? (
            this.renderCreate()
          ) : (
            this.renderAllModels()
          )}
          <div style={{ display: "none" }}>
            <input type="file" ref="file" id="fUpload" onChange={(e) => this.handleFile(e)} />
          </div>
          <UploadModal
            show={showUploadModal}
            selectedAccountId={selectedAccountId}
            handleClose={() => this.setModal(false)}
            handleUpload={() => document.getElementById("fUpload").click()}
          />
        </div>
      );
    }

    const hasPartialDep =
      model && model.plots && fieldSelect && model.plots.filter((p) => p.variable_name === fieldSelect).length > 0;

    return (
      <div className={styles.wizardMini}>
        <WizardModelContainer
          id={id}
          blueprintId={blueprintId}
          onChange={() => this.setState({ showAllModels: true })}
        />
        <div className={styles.hotdogToggle}>
          <Button
            type="secondary"
            onClick={() => {
              updateFieldSelect(undefined);
              this.setState({ showDrivers: !showDrivers });
            }}
          >
            {showDrivers ? "Back to Scenario" : "Show All Drivers"}
          </Button>
        </div>
        {(!fieldSelect || true) && this.renderSummary()}
        {(!fieldSelect || true) && this.renderDrivers()}
        <div className={styles.partialHolder} style={fieldSelect ? { height: "500px" } : { height: "0px" }}>
          <div className={styles.bHeader}>{fieldSelect}</div>
          <div className={styles.closeHolder}>
            <ButtonGroup>
              <Button type="secondary" onClick={() => this.setState({ isPartial: false })} active={!isPartial}>
                {"Driver Details"}
              </Button>
              <Button
                type="secondary"
                onClick={() => this.setState({ isPartial: true })}
                active={isPartial}
                disabled={hasPartialDep === false}
                title={
                  hasPartialDep
                    ? "Marginal Effects"
                    : "Not available for this model (" + (model ? model.label : "") + ")"
                }
              >
                {"Marginal Effects"}
              </Button>
            </ButtonGroup>
            <Button
              type="secondary"
              onClick={() => updateFieldSelect(undefined)}
              style={{ position: "absolute", right: "20px", top: "20px" }}
            >
              {"Close"}
            </Button>
          </div>
          <div style={{ height: "470px" }}>
            {isPartial ? (
              <PartialDepPlotContainer
                model={model}
                fieldSelect={fieldSelect}
                updateFieldSelect={updateFieldSelect}
                isFieldSelect={fieldSelect !== undefined}
              />
            ) : (
              <DriverGraphContainer id={id} model={model} fieldSelect={fieldSelect} />
            )}
          </div>
        </div>
      </div>
    );
  }
}
